document.addEventListener('DOMContentLoaded', function () {
<!-- Start index-banner.liquid -->
var swiper = new Swiper(".banner-slider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true, // dots pe click karke manually scroll ho sake
  },
  loop: true, // optional: agar aapko infinite scrolling chahiye
});
<!-- End index-banner.liquid -->

<!-- Start Product-Slider.liquid -->
var swiper = new Swiper(".product-slider", {
  autoHeight: true, //enable auto height
  pagination: {
    el: ".swiper-pagination",
    clickable: true, // Dots clickable hon taki manually scroll ho sake
  },
  loop: true,
  // autoplay: false // optional: autoplay mat likhiye ya hata dijiye
});



<!-- End Product-Slider.liquid -->

// FAQ collapsible section

    const wrapper = document.querySelector('.contant-wrapper');
    const headers = document.querySelectorAll('.accordion-header');
    const loadMoreBtn = document.getElementById('loadMoreFaq');
    let hiddenItems = document.querySelectorAll('.accordion-item.hidden');
    let visibleCount = 5;

    const openFirstCollapsible = wrapper.dataset.openFirst === 'true';

    const toggleAccordion = (header) => {
        const content = header.nextElementSibling;
        const isActive = content.classList.contains('show');

        document.querySelectorAll('.accordion-content.show').forEach(otherContent => {
            if (otherContent !== content) {
                otherContent.style.maxHeight = null;
                otherContent.classList.remove('show');
                otherContent.previousElementSibling.classList.remove('active');
            }
        });

        if (isActive) {
            content.style.maxHeight = null;
            content.classList.remove('show');
            header.classList.remove('active');
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('show');
            header.classList.add('active');
        }
    };

    if (openFirstCollapsible && headers.length > 0) {
        toggleAccordion(headers[0]);
    }

    headers.forEach(header => {
        header.addEventListener('click', () => toggleAccordion(header));
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            hiddenItems = document.querySelectorAll('.accordion-item.hidden');
            hiddenItems.forEach((item, index) => {
                if (index < 5) item.classList.remove('hidden');
            });

            if (document.querySelectorAll('.accordion-item.hidden').length === 0) {
                loadMoreBtn.style.display = 'none';
            }
        });
    }

    window.addEventListener('resize', () => {
        document.querySelectorAll('.accordion-content.show').forEach(content => {
            content.style.maxHeight = content.scrollHeight + 'px';
        });
    });

// end of FAQ collapsible script



});

